var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.text.slice(0,_vm.sliceTo))+" "),(_vm.dots)?_c('span',[_vm._v("....")]):_vm._e(),(_vm.text.length>200)?_c('span',{staticClass:"more ml-1",on:{"click":_vm.showMore}},[_vm._v(_vm._s(_vm.moreText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }